export const PERMISSION_CATEGORIES = [
  { key: 'overview', permissions: ['overview', 'view_all_overview', 'view_total_revenue', 'view_chart_information', 'view_total_transactions', 'view_pos_revenue', 'view_branches_revenue'] },
  { key: 'transactions', permissions: ['transactions', 'view_all_transactions'] },
  { key: 'promos', permissions: ['promos', 'view_all_promos', 'view_ongoing_campaigns', 'create_campaign', 'delete_campaign', 'view_campaign_stats', 'download_campaign_data'] },
  { key: 'branches', permissions: ['branches', 'view_branches', 'create_branches', 'delete_branches', 'edit_branches'] },
  { key: 'pos', permissions: ['pos', 'assign_pos', 'view_pos', 'create_pos', 'delete_pos', 'edit_pos'] },
  { key: 'review', permissions: ['review', 'view_all_reviews', 'reply_comments'] }
]

export const ALL_PERMISSIONS = PERMISSION_CATEGORIES.flatMap((category) => category.permissions)

export const humanizePermission = (permission) => {
  const words = permission.split('_')
  return `${words[0].charAt(0).toUpperCase()}${words[0].slice(1)} ${words.slice(1).join(' ')}`.trim()
}
